import {  Component, 
          forwardRef, 
          OnDestroy,
          OnInit,
          Input, 
          ChangeDetectionStrategy, 
} from '@angular/core';
import {  ControlValueAccessor, 
          NG_VALUE_ACCESSOR, 
          FormBuilder,
          FormGroup,          
          Validators,
          FormControl,
          NG_VALIDATORS
   } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { CertificationMainService } from 'src/app/core/services/certification-main.service';
import { LookupService } from 'src/app/core/services/lookup.service';
import { LsHelperService } from 'src/app/core/services/ls-helper.service';
import { BaseDynamicForm } from 'src/app/core/services/base-dynamic-form';
import { DynamicFormService } from 'src/app/core/services/dynamic-form.service';
import { TransactionProfileService } from 'src/app/pages/transaction/services/transaction-profile.service';
import { TransactionService } from 'src/app/pages/transaction/services/transaction.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { UserProcessProfileService } from 'src/app/core/services/user-process-profile.service';
import { Subscription } from 'rxjs';

export interface solicitantInfo {

  name: string;
  secondName: string;
  lastName: string;
  secondLastName: string;
  soliciterAddresses:string;
  socialSecurityNumber:string;
  primaryPhone: string;
  fax:string;
  birthDate: string;
  gender: string;
  feet: string;
  inches: string;
  weight: string;

}
@Component({
  selector: 'prgov-solicitante',
  templateUrl: './solicitante.component.html',
  styleUrls: ['./solicitante.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SolicitanteComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => SolicitanteComponent),
      multi: true,
    }
  ],
})
export class SolicitanteComponent extends BaseDynamicForm implements ControlValueAccessor, OnDestroy, OnInit {
    
    @Input() public isLinear: boolean;
    @Input() public isReview: boolean;
    @Input() solicitante: boolean;

    form1: FormGroup;
    genders: any;
    form2: any; 
    langKey: any = 'SELECTED_LANGUAGE';
    subscriptions: Subscription[] = [];
    profile: any;
    soliciter: any;
    feet: any;
    inches: any;
    isOver60: boolean = false;
    showPassword: boolean = false;
    solicitant: any;

    get value(): solicitantInfo {
      console.log("this.form1.value")
      console.log(this.form1.value)
      return this.form1.value;
    }
  
    set value(value: solicitantInfo) {
      this.form1.patchValue(value);
      this.onChange(value);
      this.onTouched();
    }

    constructor(    
        private route:ActivatedRoute,
        private router: Router,
        private formBuilder: FormBuilder,
        public dialog: MatDialog,
        private mainService: CertificationMainService,
        private matSnackBar: MatSnackBar,
        public translate: TranslateService,
        public lookupService: LookupService,
        public ls: LsHelperService, 
        public dynamicFormService: DynamicFormService,
        public transactionProfileService: TransactionProfileService,
        public transactionService: TransactionService,
        public authService: AuthService,
        public userProcessProfileService: UserProcessProfileService,


    ) { 
        super();  
        translate.use(this.ls.get(this.langKey));

        this.genders = [
          {
            value: 1,
            label: "gender.masculine"
          },
          {
            value: 2,
            label: "gender.femenine"
          },
      
        ];
        this.feet = [
          {
            value: 1,
            label: "1"
          },
          {
            value: 2,
            label: "2"
          },
          {
            value: 3,
            label: "3"
          },
          {
            value: 4,
            label: "4"
          },
          {
            value: 5,
            label: "5"
          },
          {
            value: 6,
            label: "6"
          },
          {
            value: 7,
            label: "7"
          },
          {
            value: 8,
            label: "8"
          },
      
        ];
        this.inches = [
          {
            value: 0,
            label: "0"
          },
          {
            value: 1,
            label: "1"
          },
          {
            value: 2,
            label: "2"
          },
          {
            value: 3,
            label: "3"
          },
          {
            value: 4,
            label: "4"
          },
          {
            value: 5,
            label: "5"
          },
          {
            value: 6,
            label: "6"
          },
          {
            value: 7,
            label: "7"
          },
          {
            value: 8,
            label: "8"
          },
          {
            value: 9,
            label: "9"
          },
          {
            value: 10,
            label: "10"
          },
          {
            value: 11,
            label: "11"
          },
        ];
       
        this.formQty = 2;
      
        this.profile = this.transactionProfileService.itemToEdit;
        this.soliciter = this.transactionService.proponent;
    }

    onChange: any = () => {};
    onTouched: any = () => {};

    writeValue(obj: any): void {
      if (obj) {
        this.value = obj;
      }    

      if (obj === null) {
        this.form1.reset();
      }
    }
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn: any): void {
      this.onTouched = fn;
    }
      
    validate(formControl: FormControl) {
      var returnValue = null;

      if(!this.form1.valid){
        returnValue = { profile: { valid: false } };;
      }

      console.log(this.form1.valid)

      return returnValue;
    }

    
    setDisabledState?(isDisabled: boolean): void {
      throw new Error('Method not implemented.');
    }

    ngOnInit() {
      this.isReview = this.mainService.certificationToShow ? true :  false;
      this.isLinear = this.mainService.certificationToShow ? false :  true;

    
      this.form1 = this.formBuilder.group({
        "name": [{value: '', disabled:this.dynamicFormService.isReadOnly}, Validators.compose([])],
        "secondName": [{value: '', disabled:this.dynamicFormService.isReadOnly}, Validators.compose([])],
        "lastName": [{value: '', disabled:this.dynamicFormService.isReadOnly}, Validators.compose([])],
        "secondLastName": [{value: '', disabled:this.dynamicFormService.isReadOnly}, Validators.compose([])],
        "soliciterAddresses": [{value: '', disabled:this.dynamicFormService.isReadOnly}, Validators.compose([])],
        "socialSecurityNumber": [{value: '', disabled:this.dynamicFormService.isReadOnly}, Validators.compose([])],
        "primaryPhone": [{value: '', disabled:this.dynamicFormService.isReadOnly}, Validators.compose([])],
        "fax": [{value: '', disabled:this.dynamicFormService.isReadOnly}],
        // "birthDate": [{value: '', disabled:this.dynamicFormService.isReadOnly}, Validators.compose([])],
        // "age": [{value: '', disabled:this.dynamicFormService.isReadOnly}, Validators.compose([])],        
        // "gender": [{value: '', disabled:this.dynamicFormService.isReadOnly}, Validators.compose([])], 
        // "feet": [{value: '', disabled:this.dynamicFormService.isReadOnly}, Validators.compose([])],
        // "inches": [{value: '', disabled:this.dynamicFormService.isReadOnly}, Validators.compose([])],
        // "weight": [{value: '', disabled:this.dynamicFormService.isReadOnly}, Validators.compose([Validators.min(1)])],         
      });  
    
      this.subscriptions.push(
        this.form1.valueChanges.subscribe(value => {
         this.onChange(value);
         this.onTouched();
       })
      )
      let userProcessId = this.transactionService.itemToEdit.Id;
      console.log("userProcessId"+ userProcessId);
      this.userProcessProfileService.getUserProcessProfiles(userProcessId).then(()=>{
    
        let profiles = this.userProcessProfileService.profiles;
        console.log('profiles' + profiles);
    
        //Selected Profile
          this.form1.controls.name.patchValue(profiles.Data.profile[0].Name);
          this.form1.controls.secondName.patchValue(profiles.Data.profile[0].SecondName);
          this.form1.controls.lastName.patchValue(profiles.Data.profile[0].LastName);
          this.form1.controls.secondLastName.patchValue(profiles.Data.profile[0].SecondLastName);          
          this.form1.controls.primaryPhone.patchValue(profiles.Data.proponent[0].Phone);

        //Proponent
          // this.form1.controls.BirthMaternalLastName.patchValue(profiles.Data.profile[0].SecondLastName);
          // this.form1.controls.BirthSecondName.patchValue(profiles.Data.profile[0].SecondName);
          // this.form2.controls.Name.patchValue(profiles.Data.proponent[0].FirstName);
          // this.form2.controls.SecondName.patchValue(profiles.Data.proponent[0].MiddleName);
          // this.form2.controls.PaternalLastName.patchValue(profiles.Data.proponent[0].FirstLastName);
          // this.form2.controls.MaternalLastName.patchValue(profiles.Data.proponent[0].SecondLastName);
        
         
         
          // this.form1.controls.EmailConfirm.patchValue(profiles.Data.proponent[0].Email);
        });

      if(this.soliciter) {
        // this.form2.controls.Name.patchValue(this.solicitant.FirstName);
        // this.form2.controls.SecondName.patchValue(this.solicitant.MiddleName);
        // this.form2.controls.PaternalLastName.patchValue(this.solicitant.FirstLastName);
        // this.form2.controls.MaternalLastName.patchValue(this.solicitant.SecondLastName);

        // this.form1.controls.phone.patchValue(this.solicitant.primaryPhone);
        // this.form1.controls.email.patchValue(this.solicitant.email);
      }

    }  
    ngOnDestroy() {
      this.subscriptions.forEach(s => s.unsubscribe());
    }
    
    toggleSSN(){
      this.showPassword = !this.showPassword;
    }

    dateValidation(control) {

      let birthDate = this.form2.controls[control].value;   
      let date = new Date();

      let birthDay = birthDate.slice(0,2);
      let birthMonth = birthDate.slice(2,4);
      let birthYear = birthDate.slice(4,8);
      let currentMonth = date.getMonth() + 1;
      let currentYear = date.getFullYear();
      let currentDay = date.getDate();
  
      if(control == 'BirthDate') {
        if(this.form1.controls.BirthDate.valid) {
          this.form1.controls.Age.setValue(this.calculateAge(birthYear, birthMonth, birthDay));
        }
        else {
          this.form1.controls.Age.setValue(0);
        }
      }
  
      try{
        let specifiedDate = Date.parse(birthYear + "-" + birthMonth + "-" + birthDay);
        let currentDate = Date.parse(currentYear + "-" + currentMonth + "-" + currentDay);

        if((specifiedDate>currentDate || !specifiedDate) && specifiedDate != 0){
          this.form1.controls[control].setErrors( {invalidDate: true} )
        }

      }catch(e){
        this.form1.controls[control].setErrors( {invalidDate: true} )
      }
      return null;              
    } 
    calculateAge(birthYear, birthMonth, birthDay) {

      var birthDate = new Date(birthYear, birthMonth, birthDay);

      let timeDiff = Math.abs(Date.now() - birthDate.getTime());

      let age = Math.floor((timeDiff / (1000 * 3600 * 24))/365.25);

      return age;
    }
  
  
    verifyAge(birthYear, birthMonth, birthDay) {

      var today = new Date();
      var birthDate = new Date(birthYear, birthMonth, birthDay);
      var age = today.getFullYear() - birthDate.getFullYear();
      var monthDiff = today.getMonth() - birthDate.getMonth();

      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
          age--;
        }
      
      this.isOver60 = age >= 60;
  
    }
  
    setValidators(locationType) {
      let state = locationType.get('State').value; 
      let country = locationType.get('Country').value; 

        if (locationType === 1) {
            state.setValidators(Validators.required)
            country.setValidators(null)
        } 
        else {      
            state.setValidators(null);
            country.setValidators(Validators.required)
        }
    }
}
